import {PropsWithChildren, ReactNode} from 'react';
import Popover from 'patient-ping-remedy/packages/popover';
import Icon, {ICONS} from 'patient-ping-remedy/packages/icon';
import {DisplaySmallTypography, StandardTypography} from 'patient-ping-remedy/packages/typography';
import {router} from '@/router';
import {WidgetHeader, WidgetHeaderAdditional} from '@common/widgets/WidgetPage.styles';
import {WidgetPageLink, WidgetWrapper} from '@common/widgets/popover/WidgetPopover.styles';
import WidgetPopoverContent from '@common/widgets/popover/WidgetPopoverContent';
import {useRosterStore} from "@/store/roster_store";

type Props<T> = PropsWithChildren & {
  isOpen: boolean;
  handleClose(isOpen: boolean): void;
  elements: T[];
  totalElements: number;
  totalUnreadElements: number;
  dateProperty: string;
  title: string;
  route: string;
  count: number;
  isLoading: boolean;
  isApiLoading: boolean;
  error: Error | null;
  markAllAsRead(): void;
  render(element: T): ReactNode;
  header?: ReactNode;
  filterBar?: ReactNode;
}

export default function WidgetPopover<T>({
  isOpen,
  handleClose,
  elements,
  totalElements,
  totalUnreadElements,
  dateProperty,
  title,
  route,
  count,
  isLoading,
  isApiLoading,
  error,
  markAllAsRead,
  render,
  header,
  filterBar,
  children,
}: Props<T>) {
  const navigate = () => {
    void router.navigate(route);
    handleClose(false);
  };

  const {currentRoster} = useRosterStore();

  return (
    <div>
      <Popover
        toggle={() => handleClose(!isOpen)}
        isOpen={isOpen}
        content={(
          <WidgetWrapper>
            <WidgetHeader>
              <DisplaySmallTypography>
                {title}
                {!currentRoster && <StandardTypography as="span"> | All groups</StandardTypography>}
              </DisplaySmallTypography>
              <WidgetHeaderAdditional concise>
                {header}
                <WidgetPageLink onClick={navigate}>
                  <Icon iconClass={ICONS.tasks} />
                </WidgetPageLink>
              </WidgetHeaderAdditional>
            </WidgetHeader>
            {filterBar}
            <WidgetPopoverContent<T>
              elements={elements}
              totalElements={totalElements}
              totalUnreadElements={totalUnreadElements}
              dateProperty={dateProperty}
              title={title}
              count={count}
              isLoading={isLoading}
              isApiLoading={isApiLoading}
              error={error}
              markAllAsRead={markAllAsRead}
              navigate={navigate}
              render={render}
            />
          </WidgetWrapper>
        )}
      >
        {children}
      </Popover>
    </div>
  );
}
